import React, { useState, useEffect } from "react";
import { socialIcons as defaultSocialIcons } from "../data/Data";

export default function SocialIcons() {
  const [settings, setSettings] = useState(() => {
    try {
      const saved = localStorage.getItem("hk_resort_settings");
      if (saved) return JSON.parse(saved);
    } catch (e) {}
    return null;
  });

  useEffect(() => {
    const handleStorage = () => {
      try {
        const saved = localStorage.getItem("hk_resort_settings");
        if (saved) setSettings(JSON.parse(saved));
      } catch (e) {}
    };
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);

  const instagramLink = settings?.instagram || defaultSocialIcons[0].link;
  const facebookLink = settings?.facebook || defaultSocialIcons[1].link;
  const youtubeLink = settings?.youtube || defaultSocialIcons[2].link;
  const locationLink = settings?.locationUrl || defaultSocialIcons[3].link;

  const showInstagram = settings?.showInstagram !== false;
  const showFacebook = settings?.showFacebook !== false;
  const showYoutube = settings?.showYoutube !== false;
  const showLocation = settings?.showLocation !== false;

  const activeIcons = [
    showInstagram && { icon: <i className="fab fa-instagram" />, link: instagramLink, name: "Instagram" },
    showFacebook && { icon: <i className="fab fa-facebook-f" />, link: facebookLink, name: "Facebook" },
    showYoutube && { icon: <i className="fab fa-youtube" />, link: youtubeLink, name: "YouTube" },
    showLocation && { icon: <i className="fas fa-map-marker-alt" />, link: locationLink, name: "Location" }
  ].filter(Boolean);

  if (activeIcons.length === 0) return null;

  return (
    <div className="hk-social-icons-container">
      {activeIcons.map((val, index) => (
        <a
          key={index}
          className="hk-bubble-icon"
          href={val.link}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={val.name}
        >
          {val.icon}
        </a>
      ))}
    </div>
  );
}

